import { useState } from "react";

const CopyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
  </svg>
);

const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

const EyeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

const EyeOffIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);

const LinkIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
    <polyline points="15 3 21 3 21 9"/>
    <line x1="10" y1="14" x2="21" y2="3"/>
  </svg>
);

export default function CuentaEspejo({ cuenta_espejo = {} }) {
  const { usuario = "", password = "", url = "" } = cuenta_espejo;

  const [copiedField, setCopiedField] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const handleCopy = async (value, field) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopiedField(field);
      setTimeout(() => setCopiedField(null), 2000);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = value;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      setCopiedField(field);
      setTimeout(() => setCopiedField(null), 2000);
    }
  };

  const CopyButton = ({ value, field }) => {
    const isCopied = copiedField === field;
    return (
      <button
        onClick={() => handleCopy(value, field)}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
          padding: "6px 14px",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          fontSize: "13px",
          fontWeight: 500,
          transition: "all 0.2s ease",
          background: isCopied
            ? "linear-gradient(135deg, #059669, #10b981)"
            : "linear-gradient(135deg, #6366f1, #818cf8)",
          color: "#fff",
          boxShadow: isCopied
            ? "0 2px 8px rgba(16,185,129,0.3)"
            : "0 2px 8px rgba(99,102,241,0.3)",
        }}
        onMouseEnter={(e) => {
          if (!isCopied) e.target.style.transform = "translateY(-1px)";
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = "translateY(0)";
        }}
      >
        {isCopied ? <CheckIcon /> : <CopyIcon />}
        {isCopied ? "Copiado" : "Copiar"}
      </button>
    );
  };

  const FieldRow = ({ label, value, field, isPassword, isUrl }) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "16px 20px",
        background: "#f8fafc",
        borderRadius: "12px",
        border: "1px solid #e2e8f0",
        gap: "12px",
        flexWrap: "wrap",
      }}
    >
      <div style={{ flex: 1, minWidth: "200px" }}>
        <div
          style={{
            fontSize: "12px",
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            color: "#64748b",
            marginBottom: "6px",
          }}
        >
          {label}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          {isUrl ? (
            <a
              href={value}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontSize: "15px",
                color: "#6366f1",
                fontWeight: 500,
                fontFamily: "'Fira Code', 'Cascadia Code', 'Consolas', monospace",
                textDecoration: "none",
                wordBreak: "break-all",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              {value} <LinkIcon />
            </a>
          ) : (
            <span
              style={{
                fontSize: "15px",
                color: "#1e293b",
                fontWeight: 500,
                fontFamily: "'Fira Code', 'Cascadia Code', 'Consolas', monospace",
                wordBreak: "break-all",
              }}
            >
              {isPassword && !showPassword ? "••••••••••" : value}
            </span>
          )}
          {isPassword && (
            <button
              onClick={() => setShowPassword(!showPassword)}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "#94a3b8",
                padding: "2px",
                display: "flex",
                alignItems: "center",
              }}
              title={showPassword ? "Ocultar" : "Mostrar"}
            >
              {showPassword ? <EyeOffIcon /> : <EyeIcon />}
            </button>
          )}
        </div>
      </div>
      <CopyButton value={value} field={field} />
    </div>
  );

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #eef2ff 0%, #e0e7ff 50%, #ede9fe 100%)",
        padding: "20px",
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "540px",
          background: "#ffffff",
          borderRadius: "20px",
          boxShadow:
            "0 20px 60px rgba(99,102,241,0.12), 0 4px 20px rgba(0,0,0,0.06)",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div
          style={{
            background: "linear-gradient(135deg, #4f46e5, #7c3aed)",
            padding: "28px 28px",
            color: "#fff",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginBottom: "6px",
            }}
          >
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "10px",
                background: "rgba(255,255,255,0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "20px",
              }}
            >
              🔐
            </div>
            <div>
              <h2 style={{ margin: 0, fontSize: "20px", fontWeight: 700 }}>
                Cuenta Espejo
              </h2>
            </div>
          </div>
        </div>

        {/* Body */}
        <div
          style={{
            padding: "24px",
            display: "flex",
            flexDirection: "column",
            gap: "14px",
          }}
        >
          <FieldRow
            label="Usuario"
            value={usuario}
            field="usuario"
          />
          <FieldRow
            label="Contraseña"
            value={password}
            field="password"
            isPassword
          />
          <FieldRow
            label="URL"
            value={url}
            field="url"
            isUrl
          />

          {/* Copy All */}
          <button
            onClick={() =>
              handleCopy(
                `Usuario: ${usuario}\nPassword: ${password}\nURL: ${url}`,
                "all"
              )
            }
            style={{
              marginTop: "8px",
              padding: "14px",
              border: "2px dashed #c7d2fe",
              borderRadius: "12px",
              background: copiedField === "all" ? "#f0fdf4" : "#fafafe",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: 600,
              color: copiedField === "all" ? "#059669" : "#6366f1",
              transition: "all 0.2s ease",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            {copiedField === "all" ? <CheckIcon /> : <CopyIcon />}
            {copiedField === "all" ? "¡Todo copiado!" : "Copiar todo"}
          </button>
        </div>
      </div>
    </div>
  );
}